"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SECOND_DEFAULT_POSITION_Y = exports.FIRST_DEFAULT_POSITION_Y = exports.DEAFULT_SIZE_HEIGHT = exports.DEFAULT_SIZE_WIDTH = exports.DEFAULT_POSITION_X = exports.TEXTTRANSFORM = exports.TEXTALIGN = exports.FONTSIZE = exports.FONTFAMILY = exports.COLOR = exports.MAX_EDITABLE_TEXT_LAYERS = void 0;
exports.MAX_EDITABLE_TEXT_LAYERS = 2;
// Style default constant values for editable text layer.
exports.COLOR = '#070809';
exports.FONTFAMILY = '"proxima-nova", "Proxima Nova", sans-serif';
exports.FONTSIZE = '14';
exports.TEXTALIGN = 'center';
exports.TEXTTRANSFORM = 'none';
// Position default constant values for editable text layer.
exports.DEFAULT_POSITION_X = 0.125;
exports.DEFAULT_SIZE_WIDTH = 0.75;
exports.DEAFULT_SIZE_HEIGHT = 0.15;
exports.FIRST_DEFAULT_POSITION_Y = 0.15;
exports.SECOND_DEFAULT_POSITION_Y = 0.8;